import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'

function Services() {
    const {data :{home: {services : {data,name}}}} = useGetSettingQuery()

    return ( 
        <div className="container-xxl py-5" id='service'>
            <div className="container">
                <div className="section-title text-center">
                    <h1 className="display-5 mb-5">{name}</h1>
                </div>
                <div className="row g-4">
                    {data.lso_services && data.lso_services.map((row,index) =>
                        <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s" key={index}>
                            <div className="service-item">
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src={row.img_image} alt=""/>
                                </div>
                                <div className="p-4 text-center border border-5 border-light border-top-0">
                                    <h4 className="mb-3">{row.txt_title}</h4>
                                    <p>{row.txe_description}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
     );
}

export default Services;